import React, { useState, useMemo, useEffect, useRef, useCallback, useContext } from "react";
import { usePersistentState } from '../hooks/usePersistentState';
import { useRequests } from "../hooks/useRequests";
import { useNotifications } from "../hooks/useNotifications";
import {
    onChangeEvent, getAddDevicePath
    //  refreshBalanceAndInvoices as refreshBalanceAndInvoicesAction
}
    from "../actions/roomOccupationActions";
import { HotelContext } from "./hotel";
import { useLanguage } from "../hooks/useLanguage";
import { rate as rateAction } from '../actions/roomOccupationActions';
import { useWebPush } from "../hooks/useWebPush";
import { UAParser } from 'ua-parser-js';
import useStayActions from "../hooks/useStayActions";
import useCheckInActions from "../hooks/useCheckInActions";
// import { useSessionPersistence } from '../hooks/useSessionPersistence';

const UserContext = React.createContext({})


function UserProvider({ children }) {
    const initialState = { inStay: false, initied: false, Room: null, Client: null, RoomOccupation: null, CheckIn: null, smartLockPinCode: null };

    const { data: hotel, getUrlPath, registerWebPush, previewMode, previewLanguage } = useContext(HotelContext)
    const [data, setData, setPartialData, getCurrentValueFromStore] = usePersistentState("user", { ...initialState }, 72000)
    const { items: requests, loading: requestsLoading, item: request, itemLoading: requestLoading, clear: clearRequests, loadItem: getRequest, loadItems: getRequests, addComment: requestAddComment, cancel: requestCancel, createRequest: requestCreate, markAsReaded, requestedCart, createPromiseUpsellComment, loadRequestedCart } = useRequests(hotel?.id, data?.RoomOccupation?.id, data?.CheckIn?.id)
    const { items: notifications, item: notification, itemLoading: notificationLoading, clear: clearNotifications, loadItem: getNotification, loadItems: getNotifications, markRead: markReadNotidication } = useNotifications(hotel?.id, data?.RoomOccupation?.id)
    const [showRequestPermissionModal, setShowRequestPermissionModal] = useState(false);
    const [stayForceInit, setStayForceInit] = useState(false);
    const [caching, setCaching] = useState(window.location.origin.indexOf('editing') === -1)
    const { language, setLanguage, setLanguageByCode, shortLanguage } = useLanguage()
    const { getBalanceAndInvoices } = useStayActions()
    const { setDoNotDisturbMode } = useCheckInActions()
    const onRoomOccupationChangeSubscription = useRef(null)
    const registerSW = useRef(null)
    // const { askNotificationPermission, getNotificationObject } = useWebPush(null, setShowRequestPermissionModal);
    // const { sessionViewer } = useSessionPersistence();
    // const sessionId = '12345678910111213141516';
    // const [ PushManager, setPushManager ] = useState(null);

    // useEffect(() => {
    //     if (!data || !data?.RoomOccupation?.id) return

    //     // console.log('>>> getRequests', data.RoomOccupation.id)
    //     // getItems(data.RoomOccupation.id).then(r => setRequests(r))
    // }, [data])

    // Monitorear cambios en data.initied
    const agent = useMemo(() => {
        const parser = new UAParser();
        return parser.getResult();
    }, [])

    const askNotificationPermission = () => {
        alert('TODO askNotificationPermission')
    }

    const getNotificationObject = () => {
        alert('TODO getNotificationObject')
    }

    const stayClear = () => {
        console.log('30sep - stayClear');
        // setData({ ...initialState });
        setPartialData({ ...initialState })
        console.log('30sep - ...initialState', { ...initialState })
        clearRequests();
        console.log('30sep - clearRequests()')
    }

    const stayConfirmInit = () => {
        console.log('30sep - stayConfirmInit ANTES - data.initied', data.initied)
        setPartialData({ initied: true })
        // setData(actual => ({ ...actual, initied: true }))
        console.log('30sep - stayConfirmInit DESPUÉS - data.initied (aún no actualizado)', data.initied)
    }

    const setCheckIn = useCallback((checkIn) => {
        console.log('30sep - setCheckIn - checkIn', checkIn);
        const payload = { CheckIn: checkIn };
        // Alinear inStay con el status al identificar, antes de que getStaybyId/stayCheckIn complete
        if (checkIn?.status === "in_stay") {
            payload.inStay = true;
        } else if (checkIn?.status === "done" || checkIn?.status === "canceled") {
            payload.inStay = false;
        }
        setPartialData(payload);
    }, [setPartialData]);

    const stayCheckIn = useCallback((values, reservation) => {
        console.log('30sep - stayCheckIn - values', values);
        console.log('30sep - stayCheckIn - reservation', reservation);

        if (values == null) {
            console.warn('stayCheckIn: payload de ocupación nulo; se omite actualización de stay en UserContext');
            return;
        }

        // Obtener el valor actual del estado para evitar problemas de closure
        const currentData = getCurrentValueFromStore();
        const incomingCheckInId = reservation?.id || values?.CheckIn?.id || null;
        // Resultado tardío de otra reserva (p.ej. identify B → A mientras getStaybyId(B) aún no resolvió).
        if (
            incomingCheckInId
            && currentData?.CheckIn?.id
            && incomingCheckInId !== currentData.CheckIn.id
        ) {
            console.warn('stayCheckIn: ignorado — check-in distinto al actual', {
                incomingCheckInId,
                currentCheckInId: currentData.CheckIn.id,
            });
            return;
        }

        const stayData = {
            // Solo true si la reserva actual está realmente in_stay (no asumir true por defecto).
            inStay: reservation?.status === "in_stay",
            // initied: true,          // TODO: initied en test
            initied: currentData?.initied || stayForceInit || false,
            smartLockPinCode: values?.CheckIn?.smartLockPinCode || null,
            Room: values.Room,
            Client: values.Client,
            RoomOccupation: {
                id: values.id,
                start: values.dateStart,
                end: values.dateEnd,
                balance: values.balance,
                showBalance: values.showBalance
            }
        }
        console.log('30sep - stayData', stayData);
        if (stayForceInit) {
            stayData["initied"] = true;
        }
        console.log('30sep - stayForceInit', stayForceInit);
        if (reservation?.status === "done" || reservation?.status === "canceled") {
            stayData['inStay'] = false;
            // stayData['initied'] = true;
        }

        // TODO::: parche
        // if (stayData["inStay"] && !stayData["initied"]) {
        //     stayData["initied"] = true;
        // }
        // ----

        setPartialData(stayData)
        console.log('30sep - stayCheckIn - stayData', stayData);
        subscribeToChanges()

        // TODO:::: elimino esto para que no se redireccione automatico a /checkin porque rompia los redirects personalizados
        // window.location.href = getUrlPath("checkin")

    }, [stayForceInit, setPartialData, getCurrentValueFromStore])

    const stayCheckOut = useCallback(() => {
        setPartialData({
            inStay: false
        })
    }, [setPartialData])

    const syncAccessContextFromStatus = useCallback((snapshot) => {
        if (!snapshot?.Room) return;
        const current = getCurrentValueFromStore();
        const prevCheckIn = current?.CheckIn;
        const nextUserPayload = { Room: snapshot.Room };
        if (prevCheckIn && typeof prevCheckIn === "object") {
            nextUserPayload.CheckIn = {
                ...prevCheckIn,
                Room: snapshot.Room,
                ...(snapshot.RoomCategory !== undefined ? { RoomCategory: snapshot.RoomCategory } : {}),
                ...(snapshot.reservation !== undefined ? { reservation: snapshot.reservation } : {}),
                ...(snapshot.placeholders !== undefined ? { placeholders: snapshot.placeholders } : {}),
            };
        }
        setPartialData(nextUserPayload);
    }, [setPartialData, getCurrentValueFromStore]);

    const urlAddDevice = useCallback(async () => {
        if (!data?.RoomOccupation?.id) return false;

        const path = await getAddDevicePath(data.RoomOccupation.id)
        return getUrlPath(path)
    }, [data?.RoomOccupation?.id])

    // useEffect(() => {
    //     sendWebPushToServer();
    // }, [data?.RoomOccupation?.id])

    const setDoNotDisturb = useCallback(async (state, cb) => {
        const currentData = getCurrentValueFromStore();
        if (!currentData?.RoomOccupation?.id) {
            return false;
        }

        try {
            const r = await setDoNotDisturbMode(currentData?.CheckIn?.id, state);

            console.log('2509 - RO', {
                RoomOccupation: {
                    ...currentData.RoomOccupation,
                    doNotDisturb: r?.data?.doNotDisturb
                }
            });

            setPartialData({
                RoomOccupation: {
                    ...currentData.RoomOccupation,
                    doNotDisturb: r?.data?.doNotDisturb
                }
            });

            if (cb) {
                cb.call(this, r);
            }
        } catch (error) {
            console.error('Error in setDoNotDisturb:', error);
            // Puedes manejar el error de otra forma si es necesario
        }
    }, [setPartialData, getCurrentValueFromStore]);

    const activeRequests = useCallback(() => {
        if (!requests) return []
        return requests.filter(i => i.status !== "done" && i.status !== "canceled")
    }, [requests])

    const inactiveRequests = useCallback(() => {
        if (!requests) return []
        return requests.filter(i => i.status === "done" || i.status === "canceled")
    }, [requests])

    const unreadNotifications = useCallback(() => {
        if (!notifications) return []
        return notifications.filter(i => i.unread)
    }, [notifications])

    const activeRequestsQty = useMemo(() => {
        return activeRequests().length
    }, [requests])

    const inactiveRequestsQty = useMemo(() => {
        return inactiveRequests().length
    }, [requests])

    const unreadNotificationsQty = useMemo(() => {
        return unreadNotifications().length
    }, [notifications])

    const refreshBalanceAndInvoices = useCallback(async () => {
        const currentData = getCurrentValueFromStore();
        if (!currentData?.RoomOccupation?.id) return;
        
        const { balance, invoices } = await getBalanceAndInvoices(currentData.RoomOccupation.id);
        const _RoomOcuupation = { ...currentData.RoomOccupation, balance: balance, invoices: invoices };
        setPartialData({ RoomOccupation: { ..._RoomOcuupation } })
    }, [setPartialData, getCurrentValueFromStore])

    React.useEffect(() => {
        subscribeToChanges()
    }, [data])

    React.useEffect(() => {
        // if (data?.RoomOccupation?.id) {
        if (hotel?.id && !registerSW.current) {
            registerSW.current = hotel.id;
            regSW(hotel);
        }
        // }
    }, [hotel])

    React.useEffect(() => {
        return () => {
            unsuscribeToChanges();
        }
    }, [])

    useEffect(() => {
        if (!previewMode || !previewLanguage || !language || previewLanguage === language) {
            return;
        }

        setLanguage(previewLanguage);
    }, [language, previewLanguage, previewMode, setLanguage])

    const subscribeToChanges = useCallback(() => {
        if (data?.RoomOccupation?.id && (!onRoomOccupationChangeSubscription.current || (onRoomOccupationChangeSubscription.current.id !== data?.RoomOccupation?.id))) {
            if (onRoomOccupationChangeSubscription.current) {
                unsuscribeToChanges();
            }
            onRoomOccupationChangeSubscription.current = {
                id: data.RoomOccupation.id,
                subscription: onChangeEvent(data.RoomOccupation.id, r => {
                    // const _RoomOccupation = { ...data.RoomOccupation };

                    const itemStored = getCurrentValueFromStore();
                    const _RoomOccupation = itemStored.RoomOccupation;
                    
                    if (r.balance !== undefined && r.balance !== null) {
                        _RoomOccupation.balance = r.balance
                    }
                    if (r.doNotDisturb !== undefined && r.doNotDisturb !== null) {
                        _RoomOccupation.doNotDisturb = r.doNotDisturb
                    }
                    if (r.showBalance !== undefined && r.showBalance !== null) {
                        _RoomOccupation.showBalance = r.showBalance
                    }
                    if (r.invoices !== undefined && r.invoices !== null) {
                        _RoomOccupation.invoices = r.invoices
                    }
                    setPartialData({ RoomOccupation: { ..._RoomOccupation } })
                })
            }
        }
        if (!data?.RoomOccupation?.id && onRoomOccupationChangeSubscription.current) {
            unsuscribeToChanges();
        }
    }, [data?.RoomOccupation?.id]);

    const unsuscribeToChanges = () => {
        if (onRoomOccupationChangeSubscription.current?.subscription) {
            try {
                if (onRoomOccupationChangeSubscription.current.subscription?.unsuscribe) {
                    onRoomOccupationChangeSubscription.current.subscription.unsuscribe();
                }
            } finally {
                onRoomOccupationChangeSubscription.current = null;
            }
        }
    }

    const safariCheckRemotePermission = function (permissionData, userData) {
        console.log('2404 - permissionData', permissionData);
        alert(permissionData.permission)
        if (permissionData.permission === 'default') {
            // This is a new web service URL and its validity is unknown.
            console.log('2004 - userData1', userData);
            window.safari.pushNotification.requestPermission(
                // 'https://atipiko.com/vico-push-notifications', // The web service URL.
                // 'https://iplsgupdjc.execute-api.eu-west-1.amazonaws.com/dev',
                'https://staging-historic-abstracts.meducar.com/safari_push',
                'web.com.vicomanager.pwa',     // The Website Push ID.
                userData, // Data that you choose to send to your server to help you identify the user.
                safariCheckRemotePermission         // The callback function.
            );
        }
        else if (permissionData.permission === 'denied') {
            // The user said no.
            alert("Denied!");
        }
        else if (permissionData.permission === 'granted') {

            alert(permissionData.deviceToken)
            // The web service URL is a valid push provider, and the user said yes.
            // permissionData.deviceToken is now available to use.
        }
    };

    const regSW = (hotel) => {
        if ('Notification' in window) {
            // if (window.Notification.permission === 'default') {
            //     setShowRequestPermission('accept');
            // } else if (window.Notification.permission === 'denied') {
            //     setShowRequestPermission('fix');
            // }

            // else {
            //   console.log('NO GRANTED')
            //   window.Notification.requestPermission(function(result) {

            //     if (result === 'denied') {
            //       console.log('Permission wasn\'t granted. Allow a retry.');
            //       return;
            //     } else if (result === 'default') {
            //       console.log('The permission request was dismissed.');
            //       return;
            //     }
            //     // Hacer algo con el permiso concedido.
            //   });
            // }
        } else {
            // console.log('0206 - regSW - NO NOTIFICATION')
        }
        if ('serviceWorker' in navigator) {
            // window.addEventListener('load', function() {
            setTimeout(() => {


                // alert('window load');

                // navigator.serviceWorker.getRegistrations().then(function(registrations) {
                //     console.log('2704- registrations', registrations)
                //     for(let     registration of registrations) {
                //         console.log('2704- registration', registration)
                //      registration.unregister()
                // } })


                // TODO:::: luego hacerlo mejor... que es detectando si estamos navegando con dominio propio o no
                let _scope = '/' + hotel.code;
                if (window.location.origin.indexOf('hotelcostagalana') !== -1 && _scope === "/costa-galana") {
                    _scope = "/";
                }
                // ----------------------------------------------

                navigator.serviceWorker.register('/service-worker.js', { scope: _scope }); //.then(serviceWorkerRegistration => console.log('2704 - sw111', serviceWorkerRegistration))

                navigator.serviceWorker.ready.catch(err => console.log('regSW - ready - error', err))

                // navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
                //     sendWebPushToServer();
                //     const notif = getNotificationObject();
                //     alert('notif');
                //     alert(notif);

                //     if (!notif || notif.permission !== 'granted') {
                //         return;
                //     }

                //     // alert('serviceWorkerRegistration');
                //     // alert(JSON.stringify(serviceWorkerRegistration))
                //     // alert('PushManager')
                //     // alert(serviceWorkerRegistration.pushManager)


                //     setPushManager(serviceWorkerRegistration.pushManager);

                //     // alert('77')
                //     if ('setAppBadge' in navigator) {
                //         navigator.setAppBadge(2)
                //     }
                //     console.log('2004 - serviceWorkerRegistration', serviceWorkerRegistration);

                //     if ('pushManager' in serviceWorkerRegistration) {
                //         serviceWorkerRegistration.pushManager
                //             .getSubscription()
                //             .then((subscription) => {
                //                 // alert('SW ready')
                //                 // alert(JSON.stringify(subscription))
                //                 // alert(data?.WebPush?.subscription?.endpoint);

                //                 let _refreshRegistrationToken = !subscription;
                //                 console.log('2404 - _refreshRegistrationToken', _refreshRegistrationToken);
                //                 if (!_refreshRegistrationToken) {
                //                     if (data?.WebPush?.subscription?.endpoint !== undefined && subscription.endpoint !== undefined && data.WebPush.subscription.endpoint !== subscription.endpoint) {
                //                         _refreshRegistrationToken = true;
                //                     }
                //                 }
                //                 console.log('2404 - _refreshRegistrationToken', _refreshRegistrationToken);
                //                 // TODO:: Parche
                //                 if (!_refreshRegistrationToken && !data?.WebPush?.id) {
                //                     _refreshRegistrationToken = true;
                //                 }
                //                 // 

                //                 if (_refreshRegistrationToken) {
                //                     alert('Refresh Subscription');
                //                     serviceWorkerRegistration.pushManager.subscribe({
                //                         userVisibleOnly: true,
                //                         applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
                //                     }).then(function(subscription) {

                //                         // alert('81')
                //                         // alert(JSON.stringify(subscription));
                //                         // alert(JSON.stringify(agent));
                //                         alert(data?.WebPush?.id)

                //                         registerWebPush(data?.WebPush?.id ? data.WebPush.id : null, agent, subscription)
                //                             .then(webPushId => {
                //                                 alert(webPushId);
                //                                 setPartialData({ WebPush: { id: webPushId, subscription: subscription } })
                //                             })

                //                     }).catch(function(e) {
                //                         alert('82')
                //                         alert(e)
                //                         // if (window.Notification && window.Notification.permission === 'denied') {
                //                         //     console.warn('Permission for notifications was denied');
                //                         // } else {
                //                         //     console.error('Unable to subscribe to push', e);
                //                         // }
                //                     });
                //                 }
                //                 // alert(JSON.stringify(subscription))
                //                 // alert(JSON.stringify(data.WebPush))




                //                 // console.log('1804 - hotel', hotel);
                //                 // if (!data.WebPush) {
                //                 //     registerWebPush(agent, subscription)
                //                 //         .then(webPushId => setPartialData({ WebPush: { id: webPushId, subscription: subscription } }))
                //                 // }
                //             })
                //             .catch((err) => {
                //                 // alert('79')
                //                 alert('306 -> ' + err.message)
                //                 console.error(`1804 - Error during getSubscription(): ${err}`);
                //             });
                //     }

                // });

                // navigator.serviceWorker.register('/service-worker.js', { scope: /* '.' */ '/' + hotel.code }).then(function(reg) {
                //     console.log('1804 - reg', reg);
                //     console.log('1804 - reg.pushManager', reg.pushManager);

                //     navigator.serviceWorker.onmessage = (messageEvent) => {
                //     const { data : event } = messageEvent.data

                //     console.log('1804 - serviceWorker.onmessage', messageEvent)
                //     // TODO::: luego hacerlo por entity y registro, y create y update
                //     //   dispatch(getList())

                //     //   if (event.checkInId) {
                //     //     dispatch(checkInNotification(event))
                //     //   }


                //     // if (event.data && event.data.type === 'REPLY_COUNT_CLIENTS') {
                //     //   console.log(event.data)
                //     // }
                //     };

                //     console.log('1804 - navigator.serviceWorker.register');
                //     console.log('1804 - data?.WebPush?.id', data?.WebPush?.id);



                //     if (!data?.WebPush?.id) {
                //         setTimeout(() => {
                //             // Chrome
                //             reg.pushManager?.subscribe({
                //                 userVisibleOnly: true,
                //                 applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
                //                 }).then(function(sub) {

                //                     registerWebPush(data.id, agent, sub)
                //                         .then(webPushId => setData({ ...data, WebPush: { id: webPushId, sub: sub } }))

                //                 }).catch(function(e) {
                //                 if (window.Notification && window.Notification.permission === 'denied') {
                //                     console.warn('Permission for notifications was denied');
                //                 } else {
                //                     console.error('Unable to subscribe to push', e);
                //                 }
                //             });


                //         }, 500);
                //     }

                //     // reg.pushManager.getSubscription().then(function(sub) {
                //     //   if (sub === null) {
                //     //     // Update UI to ask user to register for Push
                //     //     console.log('Not subscribed to push service!');
                //     //   } else {
                //     //     // We have a subscription, update the database
                //     //     console.log('Subscription object: ', sub);
                //     //   }
                //     // });
                // })
                // .catch(function(err) {
                //     console.log('Service Worker registration failed: ', err);
                // });

            }, 700);
            // });
        }

        // console.log('registeredServiceWorker --> register')
        // registeredServiceWorker = await serviceWorker.register('/service-worker.js', '/' + codeClient);
        // console.log('registeredServiceWorker', registeredServiceWorker)

        // // console.log('----- a -----')
        // // await window.Notification.requestPermission();
        // // console.log('----- b -----')

        // // const subscription = await registeredServiceWorker.pushManager.subscribe({
        // //   userVisibleOnly: true,
        // //   // applicationServerKey en Unit8Array
        // //   applicationServerKey: urlBase64ToUint8Array('BF3MOC0P-qwA1Eg-aLkf-XpkogbnsqhAqPt6QFBnU9HvqMm5LjUmh1RNjWN50wJaC7ZNZKT0YNbmrZSvlo4yqRY')
        // // });

        // console.log('----- cccc -----')

        // // console.log('subscription', subscription)

        // console.log('----- dddd -----')

        // // console.log('enablePush -- start');
        // //registeredServiceWorker.enablePush('d83c7ca893e04fbeaa99805c5ab83e6f')
        // // console.log('enablePush -- end');

        // // const applicationServerKey = 'BMGd014Dhhzs7IQ1p1FX9zwiB72TGTNndTuFUcimNeHZ-FmD4lCYR-PgC9VpsksWgGl9QgLzYrTiD_ISBfdcsqA'; // urlB64ToUint8Array('d83c7ca893e04fbeaa99805c5ab83e6f');
        // // registeredServiceWorker.pushManager.subscribe({
        // //   userVisibleOnly: true,
        // //   applicationServerKey: applicationServerKey
        // // })
        // // .then(function(subscription) {
        // //   console.log('User is subscribed:', subscription);

        // //   console.log('subscription', subscription)

        // //   // updateSubscriptionOnServer(subscription);

        // //   // isSubscribed = true;

        // //   // updateBtn();
        // // })
        // // .catch(function(err) {
        // //   console.log('Failed to subscribe the user: ', err);
        // //   // updateBtn();
        // // });

        // // registeredServiceWorker.pushManager.getSubscription()
        // // .then(function(subscription) {
        // //   isSubscribed = !(subscription === null);

        // //   if (isSubscribed) {
        // //     console.log('User IS subscribed.');
        // //   } else {
        // //     console.log('User is NOT subscribed.');
        // //   }

        // //   // updateBtn();
        // // });

    }

    // const pushManagerSubscribe = useCallback(() => {
    //     console.log('2711 - pushManagerSubscribe')
    //     console.log('2711 - pushManagerSubscribe - data', data)
    //     console.log('2711 - pushManagerSubscribe - data.WebPush', data.WebPush)
    //     navigator.serviceWorker.ready.then((sw) => {
    //         console.log('2711 - sw', sw)
    //         sw.pushManager?.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
    //             }).then(function(sub) {
    //                 let _sendToServer = !data.WebPush?.id;
    //                 if (!_sendToServer) {
    //                     if (data.WebPush?.subscription?.endpoint !== undefined && sub.endpoint !== undefined && data.WebPush.subscription.endpoint !== sub.endpoint) {
    //                         _sendToServer = true;
    //                     }
    //                 }
    //                 if (_sendToServer) {
    //                     console.log('2711 - registerWebPush')
    //                     registerWebPush(data.WebPush?.id || null, agent, sub)
    //                         .then(webPushId => {
    //                             setPartialData({ WebPush: { id: webPushId, subscription: sub } })
    //                         })
    //                 }
    //             }).catch(function(e) {
    //                 console.log('subscribe error', e)
    //             });
    //     });
    // }, [ data.WebPush ]);

    // useEffect(() => {
    //     console.log('USER DATA' , data)
    // }, [data])

    // const getNotificationObject = () => {
    //     if (window.Notification) return window.Notification;
    //     try {
    //         return Notification;
    //     } catch (err) {
    //         console.log('getNotificationObject', err);
    //     }
    //     return null;
    // }

    // const notifyMe = (cb) => {
    //     console.log('0206 - notifyMe')
    //     const notif = getNotificationObject();
    //     if (notif) {
    //         notif.requestPermission().then(result => {
    //             // setShowRequestPermission(false);
    //             if (cb) {
    //                 cb(result);
    //             }
    //             if (result === 'granted') {
    //                 pushManagerSubscribe();
    //             }
    //         })
    //     }
    //     // () => {
    //     //     // alert(window.safari.pushNotification.permission('web.com.vicomanager.pwa'));
    //     //     // setShowRequestPermission(false);
    //     //     // alert('safari' in window)
    //     //     // alert('pushNotification' in window.safari)
    //     //     if ('safari' in window && 'pushNotification' in window.safari) {
    //     //         // alert('2');
    //     //         // var permissionData = window.safari.pushNotification.permission('web.com.vicomanager.pwa');
    //     //         // alert(JSON.stringify(permissionData))
    //     //         // console.log('2004 - permissionData', permissionData)
    //     //         // const userData = {
    //     //         //     hotelId: hotel.id,
    //     //         //     sessionId: sessionId
    //     //         // }
    //     //         // alert(JSON.stringify(userData))
    //     //         // safariCheckRemotePermission(permissionData, userData);
    //     //     } else {
    //     //         // window.Notification.requestPermission(function(result) {
    //     //         // if (Notification) {
    //     //         //     Notification.requestPermission(function(result) {
    //     //         //         alert(result)
    //     //         //         setShowRequestPermission(false);
    //     //         //         if (result === 'granted') {
    //     //         //             // const notification = new Notification("Hi there!");
    //     //         //             // alert(JSON.stringify(PushManager));
    //     //         //             // if ('pushManager' in serviceWorkerRegistration) {
    //     //         //             // if (PushManager) {
    //     //         //             //     // serviceWorkerRegistration.pushManager.subscribe({
    //     //         //             //     PushManager.subscribe({
    //     //         //             //         userVisibleOnly: true,
    //     //         //             //         applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
    //     //         //             //     }).then(function(subscription) {
    //     //         //             //         // alert('81')
    //     //         //             //         // alert(JSON.stringify(subscription));
    //     //         //             //         // alert(JSON.stringify(agent));

    //     //         //             //         registerWebPush(null, agent, subscription)
    //     //         //             //             .then(webPushId => {
    //     //         //             //                 alert(webPushId);
    //     //         //             //                 setPartialData({ WebPush: { id: webPushId, subscription: subscription } })
    //     //         //             //             })

    //     //         //             //     }).catch(function(e) {
    //     //         //             //         alert('82')
    //     //         //             //         alert(e)
    //     //         //             //         // if (window.Notification && window.Notification.permission === 'denied') {
    //     //         //             //         //     console.warn('Permission for notifications was denied');
    //     //         //             //         // } else {
    //     //         //             //         //     console.error('Unable to subscribe to push', e);
    //     //         //             //         // }
    //     //         //             //     });
    //     //         //             // }
    //     //         //             console.log('2004 - Permission wasn\'t granted. Allow a retry.');
    //     //         //             return;
    //     //         //         } else if (result !== 'denied') {
    //     //         //             console.log('2004 - The permission request was dismissed.');
    //     //         //             return;
    //     //         //         }
    //     //         //         // Hacer algo con el permiso concedido.
    //     //         //     });
    //     //         // }
    //     //     }
    //     // }
    // }
    const sendWebPushToServer = () => {
        console.log('2711 - useWebPush == MAL --- sendWebPushToServer')
        // const notifObject = getNotificationObject();
        // if (notifObject && notifObject.permission === 'granted') {
        //     pushManagerSubscribe();
        // }
    }


    const value = {
        hotel,
        language,
        setLanguage,
        setLanguageByCode,
        caching,
        agent,
        setShowRequestPermissionModal,
        inStay: data && data.inStay,
        initied: data && data.initied,
        Room: data?.Room || data?.CheckIn?.Room,
        RoomCategory: data?.CheckIn?.RoomCategory,
        refreshBalanceAndInvoices,
        setCheckIn,
        stayCheckIn,
        stayConfirmInit,
        setStayForceInit,
        stayClear,
        stayCheckOut,
        syncAccessContextFromStatus,
        activeRequestsQty,
        activeRequests,
        inactiveRequestsQty,
        inactiveRequests,
        requests,
        requestsLoading,
        request,
        requestLoading,
        requestAddComment,
        requestCancel,
        requestCreate,
        getRequests,
        getRequest,
        unreadNotificationsQty,
        notifications,
        notification,
        askNotificationPermission,
        getNotificationObject,     // TODO::: ver de encapsular mas... verificar donde se usa
        getNotifications,
        getNotification,
        markReadNotidication,
        urlAddDevice,
        setDoNotDisturb,
        doNotDisturb: data?.RoomOccupation?.doNotDisturb,
        smartLockPinCode: data?.smartLockPinCode,
        hasSmartLocks: data?.Room?.smartLockIds,
        WebPush: data && data.WebPush,
        RoomOccupation: data && data.RoomOccupation, // Luego eliminar
        markAsReaded,
        requestedCart,
        createPromiseUpsellComment,
        loadRequestedCart
        // getReviewSettingById,
        // rate

    }
    return <UserContext.Provider value={value}>
        {children}

        {/* {showRequestPermissionModal && <div id="allow-push-notification-bar" class="allow-push-notification-bar">
            <div className="content text-center" style={{ position: "fixed", top: 0, left: 10, right: 10, zIndex: 1500, background: 'white', border: '1px solid #EEE', padding: '15px' }}>
                <div className="text mb-2">
                    Want to get notification from us?
                </div>
                <div className="buttons-more">
                    <button type="button" className="ok-button button-1 text-white" onClick={() => { 
                            setShowRequestPermissionModal(false);
                            askNotificationPermission()
                        }}>
                        Activar
                    </button>
                </div>
            </div>
        </div>} */}

    </UserContext.Provider>
}

export { UserProvider, UserContext }